import {Component, Input, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import {WordpressService} from "../../../services/wordpress.service";



@Component({
  selector: 'synapi-item-reviews',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './synapi-item-reviews.component.html',
  styleUrl: './synapi-item-reviews.component.scss'
})
export class SynapiItemReviewsComponent implements OnInit{
  @Input() id: number|string;
  total: number = 0;
  rates: number = 0;
  uuid: string;
  constructor(public wp :WordpressService){
    this.uuid = this.uniqueId()
  }
  async ngOnInit() {
    if(this.id){
      const reviews = await this.wp.getReviews(this.id);
      if(reviews){
        this.total = reviews.total_reviews;
        this.rates = reviews.rates;
      }
    }
  }

  uniqueId() {
    return Math.random().toString(36).substr(2, 9);
  }
}
